import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import { BModal, BToast } from 'bootstrap-vue'
import mensagens from '@/util/mensagens'
import util from '@/util'
import mascaras from '@/util/mascaras'
import ContratarProduto from '@/views/produtos/ContratarProduto'
import Plano from '@/views/contratos/Plano.vue'
import DuvidasFrequentes from '@/views/produtos/DuvidasFrequentes'
import DetalheAdicional from '@/views/produtos/DetalheAdicional'
import constants from '@/util/constants'

export default {
  name: 'mercado',
  components: {
    cabecalho,
    menuLateral,
    spinnerProcessando,
    'b-modal': BModal,
    'b-toast': BToast,
    ContratarProduto,
    Plano,
    DuvidasFrequentes,
    DetalheAdicional
  },

  computed: {
    tabelaSemRegistros () {
      return this.listaProdutos.length === 0
    }
  },

  data: () => {
    return {
      listaProdutos: [],
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      retorno: {
        sucesso: false,
        mensagem: ''
      },
      detalhes: {},
      abrirModal: false
    }
  },

  async mounted () {
    const { idProduto } = this.$route.params
    await this.obterListaProdutos()
    if (!util.valorEhNulo(idProduto) && !isNaN(Number(idProduto)) && Number(idProduto) !== constants.idProdutoMirt) {
      const produto = this.listaProdutos.find(produto => produto.id === Number(idProduto))
      await this.showModalContratarProduto(produto)
    }
  },

  methods: {
    async obterListaProdutos () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
        const resposta = await this.axios.get('/manager/conta/produtos')
        this.listaProdutos = resposta.data.retorno.dados
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    obterProdutoPorId (id) {
      return this.listaProdutos.find(produto => produto.id === id)
    },
    obterPlanoPorId (planos, id) {
      return planos.find(plano => plano.id === id)
    },
    async showModalContratarProduto (produto) {
      this.abrirModal = true
      this.detalhes = produto
      await this.$nextTick(async () => {
        await this.$bvModal.show('modalDetalheAdicional')
      })
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },
    mascaraMonetaria (valor) {
      return mascaras.mascaraMonetaria(valor)
    },
    formatarValorMonetario (valor) {
      if (util.valorEhNulo(valor)) return 'R$ 0'
      return util.formatarValorMonetarioComCifrao(valor, { minimumFractionDigits: 0 })
    },
    obterPlanoSugerido (produto) {
      return produto.planos.find(plano => plano.sugerido === true)
    },
    obterItemPlano (planoSugerido) {
      return planoSugerido.item_planos.find(item => item.plano === planoSugerido.id)
    },
    obterItemPlanoSugerido (produto) {
      const planoSugerido = this.obterPlanoSugerido(produto)

      if (util.valorEhNulo(planoSugerido)) return
      return planoSugerido.item_planos.find(item => item.plano === planoSugerido.id)
    },
    obterValorPlanoSugerido (produto) {
      const planoSugerido = this.obterPlanoSugerido(produto)

      if (util.valorEhNulo(planoSugerido)) return

      const itemPlano = this.obterItemPlano(planoSugerido)

      const quantidade = itemPlano?.quantidade > 0 ? itemPlano?.quantidade : 1

      const valor = planoSugerido.valor / quantidade

      return valor
    },

    verificaSeProdutoECredito (produto) {
      return produto.planos.some(plano => plano.tipo === constants.tipoPlano.credito)
    },

    obterDescricaoPlanoSugerido (produto) {
      const planoSugerido = this.obterPlanoSugerido(produto)

      return planoSugerido?.descricao
    },

    listaItemProdutosSemRegistros (plano) {
      return plano.item_planos.length === 0
    }
  }
}
